import {createSlice} from '@reduxjs/toolkit';
//types
import {IOrganizationAttendeesContributionsReducer} from '../../utils/types';
//actions
import {getAttendeesContributions} from './actions';
//operations
import {getAttendeeContributionOperation, pendingOperation, rejectedOperation} from './operations';
//constants
import {initialAttendeeContributionsData} from '@/utils/constants';

export const initialState: IOrganizationAttendeesContributionsReducer = {
	attendeeContributions: initialAttendeeContributionsData,
	isLoading: false,
};

const organizationAttendeesContributionsStore = createSlice({
	name: 'organizationAttendeesContributions',
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder.addCase(getAttendeesContributions.pending, pendingOperation);
		builder.addCase(getAttendeesContributions.fulfilled, getAttendeeContributionOperation);
		builder.addCase(getAttendeesContributions.rejected, rejectedOperation);
	},
});

export default organizationAttendeesContributionsStore.reducer;
